import React from 'react'

import s from './styles.module.scss'

import { getHouseProvisionsSectionTitle } from './getHouseProvisionsSectionTitle'
import { mainPictureByServiceProviderType } from '../service-header/mainPictureByServiceProviderType'
import { ServiceProviderCategoryEnum } from '../../../../../lib/graphql'

const HouseProvisionsSectionHeader = ({
  category,
}: {
  category: ServiceProviderCategoryEnum
}) => {
  return (
    <div className={s.container}>
      {category === ServiceProviderCategoryEnum.BATCH_PROVISIONS ? (
        <h4 className={s.batchProvisionsTitle}>
          {getHouseProvisionsSectionTitle(category)}
        </h4>
      ) : (
        <>
          <div className={s.imageService}>
            <div className={s.emptyState}>
              {mainPictureByServiceProviderType(category ?? undefined)}
            </div>
          </div>
          <h4 className={s.title}>
            {getHouseProvisionsSectionTitle(category)}
          </h4>
        </>
      )}
    </div>
  )
}

export default HouseProvisionsSectionHeader
